exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".standout[data-v-9647d9fc]{font-weight:700;color:#444}.description[data-v-9647d9fc]{font-style:italic;font-size:12px;word-break:break-word;color:#888}.not-final[data-v-9647d9fc]{font-size:20px;font-weight:700;color:#909399}.printable-title.top[data-v-9647d9fc]{margin-top:0}.standout-accent[data-v-9647d9fc]{color:#dd711f}.serves[data-v-9647d9fc]{color:#444}.po-title[data-v-9647d9fc]{font-size:16px;font-weight:700;color:#dd711f}.order-title[data-v-9647d9fc]{font-size:16px;font-weight:700;color:#444}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9647d9fc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/print/OrderUserPDF.vue
// module id = 513
// module chunks = 0